import { Component, Input } from '@angular/core';
import { GuarantorFormGroup } from '../../../../shared/form-groups/guarantor.form-group';

@Component({
  selector: 'app-guarantor-form',
  templateUrl: './guarantor-form.component.html',
  styleUrl: './guarantor-form.component.scss',
  standalone: false
})
export class GuarantorFormComponent {
  @Input({ required: true }) applicantFormGroup!: GuarantorFormGroup;
  /** When true, email is readonly (e.g. after co-applicant has been saved). */
  @Input() readonlyEmail = false;
  /** When provided, shows a tooltip by the email field (e.g. when email is readonly after save). */
  @Input() emailTooltipText?: string;
}
